import React from "react";

import { useTranslation } from "react-i18next";

import { ThaiLifeBackButtonProps } from "../../types/ThaiLifeBackButton";

function ThaiLifeBackButton({ redirectUrl }: ThaiLifeBackButtonProps) {
  const { t } = useTranslation();

  return (
    <button
      className="bg-[#026540] text-center h-full p-[5px] text-white rounded-[5px] underline cursor-pointer w-[100px]"
      onClick={() => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }}
    >
      {t("pages.register.buttons.back")}
    </button>
  );
}

export default ThaiLifeBackButton;
